import { fetchSameOrigin } from '../../Utils';
function issueFreeConsultation (memberId) {
  return fetchSameOrigin(`/members/${memberId}/member_offers/issue_free_visit`, 'POST')
  .then(resp => resp.json().then(data => new Promise((resolve) => {
    window.location.reload();
    resolve();
  })));
}
export default issueFreeConsultation;
